import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer>
      <Container fluid style={{ backgroundColor: "#c3d2e8" }}>
        <Row className='py-3'>
          <Row className=''>
            <Col className="text-center">
              Copyright &copy; 2024, TGIT Bangladesh
            </Col>
          </Row>

          <Row className=''>
            <Col className="text-center">
              Designed & Developed by
              <a
                target="blank"
                href="https://www.tgitbangladesh.com"
                style={{ textDecoration: "none" }}
                className="text-info"
              >
                &nbsp;TGIT Bangladesh
              </a>
            </Col>
          </Row>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
